// extracted by mini-css-extract-plugin
export default {"sticky_container":"_3UU3O8iU","sticky_element":"_2ZePardp"};